module.exports = __webpack_public_path__ + "static/media/kranenburgh-min.7304b94a.png";